<div class="row wrapper border-bottom white-bg page-heading">
  <div class="col-lg-12">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <a [routerLink]="['/home']">Home</a>
      </li>
      <li class="breadcrumb-item">
        <a>User Statistics</a>
      </li>
    </ol>
  </div>
</div>
<div class="wrapper wrapper-content  animated fadeInRight">
  <div class="row">
    <div class="col-6">
      <div class="card">

        <div class="card-body">

          <div class="d-flex align-items-center mb-3">
            <div class="flex-fill fw-bold fs-16px">Active Users</div>
          </div>

          <div>
            <ul class="list-group">
              <li *ngFor="let page of pages" class="list-group-item">
                <a href="#{{page.url}}">{{ page.url }}</a>
                <ul *ngFor="let user of page.users">
                  <div class="row mb-2">
                    <div class="col-6">{{user.name}}</div>
                    <div class="col-6 text-center">{{user.age}}</div>
                  </div>
                </ul>
              </li>
            </ul>

           
          </div>
        </div>


        <div class="card-arrow">
          <div class="card-arrow-top-left"></div>
          <div class="card-arrow-top-right"></div>
          <div class="card-arrow-bottom-left"></div>
          <div class="card-arrow-bottom-right"></div>
        </div>

      </div>
     
    </div>
    <div class="col-6">
      
    </div>

  </div>